import { render, staticRenderFns } from "./CreateDocument.vue?vue&type=template&id=3f722f41&scoped=true&"
import script from "./CreateDocument.vue?vue&type=script&lang=js&"
export * from "./CreateDocument.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocument.vue?vue&type=style&index=0&id=3f722f41&scoped=true&lang=scss&"
import style1 from "./CreateDocument.vue?vue&type=style&index=1&id=3f722f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f722f41",
  null
  
)

export default component.exports